import { webSocket } from '@store/actions';
import { LiveDataState } from './types';
import { TelemetryTypes } from './enums';
import { useHasSmartMeter, useHasGcp, useAppSelector } from '@store/selectors';

type Telemetries = LiveDataState['telemetries'];

// prettier-ignore
export const useTelemetries = <K extends keyof Telemetries>(
    branch: K,
): Telemetries[K] => useAppSelector((state) => state.liveData.telemetries[branch]);

export const useLiveDataLoading = () => {
    const min = !!webSocket ? 1 : 2;
    const hasGCP = useHasGcp();
    const pvEvents = useTelemetries(
        TelemetryTypes.PV_BATTERY,
    ).telemetriesReceived;
    const gcpEvents = useTelemetries(TelemetryTypes.GCP).telemetriesReceived;
    const hasSmartMeter = useHasSmartMeter();

    if (hasSmartMeter) {
        return pvEvents < min;
    }

    return hasGCP ? pvEvents < min || gcpEvents < min : pvEvents < min;
};

export const useIsEvPluggedIn = () =>
    useAppSelector(
        (state) => state.liveData.telemetries.emobility.wallbox.isEvPluggedIn,
    );

export const useIsAwaitingSmartChargingUserSoc = () =>
    useAppSelector(
        (state) =>
            state.liveData.telemetries.emobility.wallbox
                .isAwaitingSmartChargingUserSoc,
    );

export const useGridxInterventions = () =>
    useAppSelector((state) => {
        const interventions = state.liveData.interventions.gridx.list;

        return Object.values(interventions).filter(
            (intervention) => intervention.status === 'OPEN',
        );
    });

/** Returns the timestamp (ms) of the last received ev-link-complete WS event, or null. */
export const useLastEvLinkCompleteAt = () =>
    useAppSelector((state) => state.liveData.lastEvLinkCompleteAt);
